var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveModal = function SvgSaveModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#F0B51A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "save_modal_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 27,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 32.082 6.416)",
    fill: "#D9D9D9",
    d: "M32.082 6.416h25.667v25.667H32.082z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#save_modal_svg__a)",
    stroke: "#fff",
    strokeWidth: 1.283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.996 29.064H12.753a2.034 2.034 0 0 1-2.034-2.034V12.788a2.034 2.034 0 0 1 2.034-2.035h11.19l5.087 5.086v11.19a2.035 2.035 0 0 1-2.034 2.035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96 29.063v-8.138H14.787v8.138M14.787 10.753v5.086h8.139"
  }))));
};
export default SvgSaveModal;